import { useAuthContext } from "../hooks/useAuthContext"
import { useState, useEffect } from "react";
import axios from "axios";

const IsAuthorized = (requiredPermission) => {
  const { user } = useAuthContext();
  const clubDetailsRaw = localStorage.getItem("club_details");
  const clubDetails = clubDetailsRaw ? JSON.parse(clubDetailsRaw) : null;
  const clubId = clubDetails?.club_id ?? null;
  const [userRoles, setUserRoles] = useState([]);
  const [permissions, setPermissions] = useState([])
  const [filteredRoles, setFilteredRoles] = useState([]);

  useEffect(() => {
    user && fetchUserRoles()
  }, [])

  const fetchUserRoles = async () => {
    try {
      // console.log("XXXXXXXXXXXXXXXXXXXXXXX");
      const response = await axios.get(`/api/roles/user-roles`, {
        params: { userId: user?.userId },
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json",
        },
      });
      // console.log("YYYYYYYYYYYYYYYYYYYYY");

      setUserRoles(response.data);
    } catch (error) {
      // console.log("ZZZZZZZZZZZZZZZZZZZZZZZZZ");
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    user && fetchPermissions()
  }, [filteredRoles])

  const fetchPermissions = async () => {
    try {
      // console.log("LLLLLLLLLLLLLLLLLLLLLLLL");
      const permissionsResponses = await Promise.all(
        filteredRoles.map((role) =>
          axios.get(`/api/roles/role-permissions/${role.id}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
              "Content-Type": "application/json",
            },
          })
        )
      );

      // console.log("MMMMMMMMMMMMMMMMMMMMMMMMMMMM");

      const newPermissions = new Map();
      permissionsResponses.forEach((response) => {
        response.data.forEach((p) => newPermissions.set(p.permission, p));
      });

      const permissionNames = Array.from(newPermissions.keys());
      // console.log("NNNNNNNNNNNNNNNNNNNNNNNN");

      setPermissions(permissionNames);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    setFilteredRoles(userRoles.filter((role) => role.club_id == clubId))
  }, [clubId, userRoles])

  return user?.role == "club_manager" || user?.role == "super_admin" || user?.role == "cloud_admin" ? true : permissions.includes(requiredPermission)
}

export default IsAuthorized